import React from 'react';

const SubtleOrbs = () => (
  <div className="fixed inset-0 pointer-events-none overflow-hidden">
    {[...Array(3)].map((_, i) => (
      <div
        key={i}
        className="absolute rounded-full blur-3xl opacity-5"
        style={{
          background: 'radial-gradient(circle, #C8A96E, transparent)',
          width: `${Math.random() * 400 + 200}px`,
          height: `${Math.random() * 400 + 200}px`,
          left: `${Math.random() * 100}%`,
          top: `${Math.random() * 100}%`,
          animation: `float ${Math.random() * 20 + 20}s infinite ease-in-out`,
          animationDelay: `${Math.random() * 10}s`
        }}
      />
    ))}
  </div>
);

export default SubtleOrbs;
